document.addEventListener("DOMContentLoaded", function () {
  var sliders = document.querySelectorAll(".about-company-swiper");
  if (!sliders || sliders.length === 0) return;

  sliders.forEach(function (el) {
    // eslint-disable-next-line no-undef
    var paginationEl = el.querySelector(".swiper-pagination");
    var prevEl = el.querySelector(".swiper-button-prev");
    var nextEl = el.querySelector(".swiper-button-next");

    var config = {
      slidesPerView: 3,
      spaceBetween: 16,
      loop: true,
      watchOverflow: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
            slidesPerView: 1
        },
        600: {
          slidesPerView: 2,
        },
        767: {
          slidesPerView: 3,
        },
      }
    };

    if (paginationEl) {
      config.pagination = {
        el: paginationEl,
        clickable: true
      };
    }
    if (prevEl || nextEl) {
      config.navigation = {
        prevEl: prevEl,
        nextEl: nextEl
      };
    }

    new Swiper(el, config);
  });
});
